import React from "react";

const Spinner = () => {
  return (
    <div className="spinner-border text-light" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
